import { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { connect } from 'react-redux';

/**
 * @description
 * Synchronizes the authenticated Redux user with the LaunchDarkly client context.
 * This ensures feature flag evaluations reflect the current user's segment membership.
 */
const LDUserSync = ({ user }) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (!ldClient || !user?.email) return;

    const userContext = {
      key: user.email,
      email: user.email,
      name: [user.firstName, user.lastName]
        .filter(Boolean)
        .join(' ')
        .trim(),
    };

    ldClient.identify(userContext).catch(() => {
      if (process.env.NODE_ENV === 'development') {
        console.warn('[LaunchDarkly] identify() failed for user:', userContext.email);
      }
    });
  }, [ldClient, user]);

  return null;
};

export default connect(state => ({ user: state.user }))(LDUserSync);
